import { Injectable } from '@angular/core';
import {ApiClient} from "../../shared/api/api";
import {Observable} from "rxjs";
import {Statistics} from "../models/statistics.model";
import {ApiResponse} from "../models/model";

@Injectable({
  providedIn: 'root'
})
export class StatisticService {

  private endpoint = 'api/admin/dashboard';
  private endpointEnterprise = 'api/enterprise/dashboard';


  constructor(private apiClient: ApiClient) {}
  dashboard(startDate: string, endDate: string, companyId?: string): Observable<ApiResponse<Statistics>> {
    const params = new URLSearchParams({
      startDate: startDate,
      endDate: endDate,
    });

    if (companyId) {
      params.append('companyId', companyId);
    }

    return this.apiClient.getAll<ApiResponse<Statistics>>(`${this.endpoint}?${params.toString()}`);
  }
  dashboardEnterprise(startDate: string, endDate: string): Observable<ApiResponse<Statistics>> {
    const params = new URLSearchParams({
      startDate: startDate,
      endDate: endDate,
    });


    return this.apiClient.getAll<ApiResponse<Statistics>>(`${this.endpointEnterprise}?${params.toString()}`);
  }
}
